<template>
    <div class="pop-up--form card card--lg">
        <address-update-form v-if="step === 'UPDATE'" :user="user"></address-update-form>
        <address-update-valid v-if="step === 'VALID'"></address-update-valid>
        <address-update-unvalid v-if="step === 'UNVALID'"></address-update-unvalid>
    </div>
</template>

<script>
export default {
    props: ['address'],

    data() {
        return {
            step: 'UPDATE',
        }
    },
}
</script>
